import { VueController } from 'util/vue-controller'

// Connects to data-controller="availability"
export default class extends VueController {
  static vueComponent = 'availability-preview'

  static values = {
    config: Object,
    date: String
  }

  get props () {
    return {
      config: this.configValue,
      date: this.dateValue
    }
  }
}
